import useAccountInfo from "@/hooks/useAccountInfo";
import { api } from "@/lib/api-client";
import { sentryLog } from "@/utils/sentry-utils";
import { clearOriginalTokenForInfiltration } from "@/utils/infiltrationSession";
import { tearDownTapToPay } from "@/utils/tap-to-pay/sumup";

export function useLogout() {
  const accountInfo = useAccountInfo((state) => state.accountInfo);

  const { mutateAsync: endImpersonation } =
    api.impersonation.useEndImpersonation();

  const { mutateAsync: deleteCookie } = api.cookie.useDeleteHttpCookie();

  // Best-effort: a session left open still expires with its token, so a failure
  // here must not block the admin from getting out of the impersonation.
  async function closeImpersonationSession() {
    if (!accountInfo.superAdmin) {
      return;
    }

    try {
      await endImpersonation();
    } catch (e) {
      sentryLog.error("Failed to close impersonation session", {
        clientId: accountInfo.clientId,
        error: e instanceof Error ? e.message : String(e),
      });
    }
  }

  async function logout(source: string) {
    sentryLog.debug(`Logout user - ${source}`, {
      clientId: accountInfo.clientId,
    });

    await closeImpersonationSession();
    localStorage.removeItem("usr_token");
    clearOriginalTokenForInfiltration();
    localStorage.removeItem("pos-businessPremiseId");
    localStorage.removeItem("pos-electronicDeviceId");

    // revoke hubspot identity
    window._hsq = window._hsq || [];
    window._hsq.push(["revokeCookieConsent"]);

    // Await so the pos-token cookie is actually cleared before the reload
    // cancels in-flight requests; swallow failures so logout still completes.
    try {
      await deleteCookie({ cookieName: "pos-token" });
    } catch {
      // best-effort; proceed with teardown regardless
    }

    await tearDownTapToPay();

    // @ts-expect-error - correct
    window?.productFruits?.services?.destroy();
    window.location.reload();
  }

  return { logout, closeImpersonationSession };
}
